'use client';
import React from 'react';

import { AnimationState, defaultAnimationState } from '@/lib/motion/utils';

export const AnimationContext = React.createContext<{
  enableAnimation: AnimationState;
  setEnableAnimation: React.Dispatch<React.SetStateAction<AnimationState>>;
}>({
  enableAnimation: defaultAnimationState,
  setEnableAnimation: () => {},
});

export const useAnimationContext = () => {
  const context = React.use(AnimationContext);
  if (!context) {
    throw new Error(
      'useAnimationContext must be used within AnimationContext.Provider'
    );
  }
  return context;
};

export const AnimationProvider: React.FC<{
  children: React.ReactNode;
  enableAnimation?: AnimationState;
}> = ({ children, enableAnimation = defaultAnimationState }) => {
  const [enableAnimationState, setEnableAnimationState] =
    React.useState<AnimationState>(enableAnimation);

  return (
    <AnimationContext
      value={{
        enableAnimation: enableAnimationState,
        setEnableAnimation: setEnableAnimationState,
      }}
    >
      {children}
    </AnimationContext>
  );
};
